import { render, staticRenderFns } from "./remindDlalog.vue?vue&type=template&id=9faa7ab4&"
import script from "./remindDlalog.vue?vue&type=script&lang=js&"
export * from "./remindDlalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports